import React, { Fragment } from "react";

// // Redux
// import { useDispatch } from "react-redux";
// import { compose } from "redux";

// // Redux Actions
// import {
//   toggleMailingDrawer,
//   toggleTemplateDrawer,
// } from "../../../../../common/UserDataReducer";

function Footer({
  isEdit = false,
  isMutationButtonDisabled = false,
  onSubmitHandler = () => console.log("No onSubmitHandler provided to Footer"),
  onClose = () => console.log("No onClose provided to Footer"),
}) {
  // const dispatch = useDispatch();
  return (
    <Fragment>
      <section className="request-mutation-modal-footer-btns">
        {/* <button
          disabled={isEdit}
          className="secondary-button"
          onClick={() => compose(dispatch, toggleTemplateDrawer)(true)}
        >
          Create Template
        </button>
        <button
          disabled={isEdit}
          className="secondary-button"
          onClick={() => compose(dispatch, toggleMailingDrawer)(true)}
        >
          Create Mailing List
        </button> */}
      </section>
      <section className="request-mutation-modal-footer-btns">
        <button className="secondary-button" onClick={() => onClose()}>
          Cancel
        </button>
        <button
          className="primary-button"
          disabled={isMutationButtonDisabled}
          onClick={onSubmitHandler}
        >
          {isEdit ? "Save Changes" : "Create Request"}
        </button>
      </section>
      <section></section>
    </Fragment>
  );
}

export default Footer;
